import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { TramosCodigoEmpleado } from '../models/tramosCodigoEmpleado.model';
import { TramosCodigoEmpleadoRequest } from '../models/tramosCodigoEmpleadoRequest.model';

@Injectable()
export class TramosCodigoEmpleadosService extends HttpClientBaseService implements IServiceBase<TramosCodigoEmpleado>
{
    constructor(_http: HttpClient) {
        super(_http, 'gestionEmpleados/', '', false);
    }

    getAllModels(parentId?: any, params?: HttpParams): Observable<TramosCodigoEmpleado[]> {
        throw new Error('Method not implemented.');
    }
    getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<TramosCodigoEmpleado>> {
        throw new Error('Method not implemented.');
    }
    getModel(id: any, parentId?: any): Observable<TramosCodigoEmpleado> {
        throw new Error('Method not implemented.');
    }

    guardarTramosCodigo(companyCode: any, tramos: TramosCodigoEmpleadoRequest) {
        return this.http.put<TramosCodigoEmpleado>(`${this.getUrl()}${companyCode}/updatetramos`, tramos)
    }

    obtenerTramosCodigo(companyCode: number): Observable<TramosCodigoEmpleado> {
        return this.http.get<TramosCodigoEmpleado>(`${this.getUrl()}${companyCode}/tramoscodigos`)
    }
}
